import { render, staticRenderFns } from "./PageDivider.vue?vue&type=template&id=f23130be&scoped=true"
import script from "./PageDivider.vue?vue&type=script&lang=js"
export * from "./PageDivider.vue?vue&type=script&lang=js"
import style0 from "./PageDivider.vue?vue&type=style&index=0&id=f23130be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23130be",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PageDivider.vue
// module id = 111
// module chunks = 0